'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _CvForm = _interopRequireDefault(require("Components/Forms/Models/Cv/CvForm"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class CandidateCvPage extends _react.Component {
  state = {
    loading: false,
    slug: document.location.pathname.split('/mon-cv/')[1],
    type: ''
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCv();
  }
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-all', {
      candidate_id: state.slug
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        cv: response.cvs[0] || {},
        type: response.cvs[0] ? 'update' : ''
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let account_status = app.state.session?.user?.account_status;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Mon CV | AspieJob"
    }, props), account_status === "waiting" || account_status === "exit" || account_status === "refused" ? /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account u-margin-top-30"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "u-full-width u-text-center"
    }, "Vous aurez acc\xE8s \xE0 nos services apr\xE8s votre premier rendez-vous. Nous vous contacterons prochainement. Si besoin, contactez- nous sur \xAB contact@aspiejob.org \xBB")) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center "
    }, "Mon CV"), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account"
    }, state.cv ? /*#__PURE__*/_react.default.createElement(_CvForm.default, {
      type: state.type
    }) : undefined)));
    return output;
  }
}
exports.default = CandidateCvPage;
